import { render, staticRenderFns } from "./RoomDetail.vue?vue&type=template&id=e5b3149a&scoped=true&"
import script from "./RoomDetail.vue?vue&type=script&lang=js&"
export * from "./RoomDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b3149a",
  null
  
)

export default component.exports